import React, { useEffect, useState } from "react";
import GreenButton from "../../../components/GreenButton/GreenButton";
import { useMediaQuery } from "@mui/material";
import BlueButton from "../../../components/BlueButton/BlueButton";
import { DataGrid } from "@mui/x-data-grid";
import SwipeableModals from "../SwipeableModals/SwipeableModals";
import MessageModals from "../../../components/MessageModals/MessageModals";
import DeleteUser from "./../../../assets/delete.svg";
import ShowUser from "./../../../assets/show-user.svg";
import EditUser from "./../../../assets/edit-user.svg";
import AddGif from "./../../../assets/add-gif.gif";
import api from "../../../utils/api";

const Terms = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1024px)");
  const [termsView, setTermsView] = useState("App");
  const [isOpen, setIsOpen] = useState(false);
  const [currentModalView, setCurrentModalView] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTerm, setSelectedTerm] = useState(null);
  const [termToDelete, setTermToDelete] = useState(null);

  useEffect(() => {
    getData();
  }, [termsView]); // Refresh when switching between App and site views

  const getData = async () => {
    setLoading(true);
    try {
      const res = await api.get(
        `/terms?type=${termsView === "Web" ? "site" : "app"}`
      );
      setData(res.data.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleOpen = (view, term = null) => {
    setSelectedTerm(term);
    setCurrentModalView(view);
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setSelectedTerm(null);
  };

  const actionColumn = [
    {
      field: "index",
      headerName: "#",
      minWidth: 20,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "title_ar",
      headerName: "عنوان النص بالعربي",
      flex: 1,
      minWidth: 160,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => params?.row?.title_ar || "",
    },
    {
      field: "title_en",
      headerName: "عنوان النص بالانجليزية",
      minWidth: 160,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => params?.row?.title_en || "",
    },
    {
      field: "content_ar",
      headerName: "النص بالعربية",
      flex: 1,
      minWidth: 160,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => params?.row?.content_ar || "",
    },
    {
      field: "content_en",
      headerName: "النص بالانجليزية",
      flex: 1,
      minWidth: 160,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => params?.row?.content_en || "",
    },
    {
      field: "country",
      headerName: "البلد",
      minWidth: 160,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => params?.row?.country?.name_ar || "",
    },

    {
      field: "action",
      headerName: "",
      width: 240,
      headerAlign: "center",
      align: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="cell-action">
            <div
              className="cell-btn"
              onClick={() => handleOpen("viewTerm", params?.row)}
            >
              <img src={ShowUser} alt="" />
            </div>

            <div
              className="cell-btn"
              onClick={() => handleOpen("editTerm", params?.row)}
            >
              <img src={EditUser} alt="" />
            </div>

            <div
              className="cell-btn"
              onClick={() => {
                setTermToDelete(params.row);
                setOpenDelete(true);
              }}
            >
              <img src={DeleteUser} alt="" />
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="departments-container">
      <div className="actions-container">
        <div className="btns-container">
          <GreenButton
            text="التطبيق"
            size={isMobile ? "full" : isTablet ? "fit" : "medium"}
            variant={termsView === "App" ? "fill" : "outlined"}
            onClick={() => setTermsView("App")}
          />

          <GreenButton
            text="الموقع"
            size={isMobile ? "full" : isTablet ? "fit" : "medium"}
            variant={termsView === "Web" ? "fill" : "outlined"}
            onClick={() => setTermsView("Web")}
          />
        </div>

        <BlueButton
          text="اضافة شرط جديد"
          size={isMobile ? "full" : isTablet ? "fit" : "large"}
          variant="fill"
          onClick={() => handleOpen(`create${termsView}Term`)}
          icon={<img src={AddGif} alt="" />}
        />
      </div>

      <DataGrid
        sx={{ backgroundColor: "white", width: "100%" }}
        autoHeight={true}
        columns={actionColumn}
        rows={data.map((row, index) => ({
          ...row,
          index: index + 1,
        }))}
        disableVirtualization
        disableColumnFilter
        disableColumnMenu
        hideFooter
        rowHeight={60}
        loading={loading}
      />

      <SwipeableModals
        open={isOpen}
        onClose={handleClose}
        onOpen={() => setIsOpen(true)}
        currentView={currentModalView}
        initialData={selectedTerm}
        refreshData={getData}
      />

      <MessageModals
        open={openDelete}
        currentView="delete"
        onDataChange={getData}
        onClose={() => setOpenDelete(false)}
        message="هل أنت متأكد من حذف هذا الشرط؟"
        route={`/terms/${termToDelete?.id}`}
        text="تم حذف الشرط بنجاح"
      />
    </div>
  );
};

export default Terms;
